import * as React from "react";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import { Facebook, Instagram, Twitter, LinkedIn } from "@mui/icons-material";
import { Box, Container, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { AppState } from "../../../redux/reducer/rootReducer";

export const Footer: React.FunctionComponent = () => {
  const setting = useSelector(
    (state: AppState) => state.shoppingPortalReducer.portalSettings?.setting
  );
  const locations = useSelector(
    (state: AppState) =>
      state.shoppingPortalReducer.portalSettings?.dmsLocations
  );

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: (theme) =>
          theme.palette.mode === "light"
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
        p: 6,
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={5}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Contact Us
            </Typography>

            <Typography variant="body2" color="text.secondary">
              Email: {setting?.email}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Phone: {setting?.primaryPhone}
              <div style={{ marginLeft: "11%" }}>{setting?.secondaryPhone}</div>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Locations
            </Typography>
            {locations && locations?.length > 0
              ? locations.map((loc, index: number) => (
                  <Typography
                    key={index}
                    mt={1}
                    variant="body2"
                    color="text.secondary"
                  >
                    {loc.name}
                    <br></br>
                    {loc.address + " " + loc.city}
                    <br></br>
                  </Typography>
                ))
              : ""}
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Follow Us
            </Typography>
            <Link
              target="_blank"
              href={
                setting?.socialLinks.find(
                  (link) => link.linkType === "Facebook"
                )?.linkUrl
              }
              color="inherit"
            >
              <Facebook />
            </Link>
            <Link
              target="_blank"
              href={
                setting?.socialLinks.find(
                  (link) => link.linkType === "Instagram"
                )?.linkUrl
              }
              color="inherit"
              sx={{ pl: 1, pr: 1 }}
            >
              <Instagram />
            </Link>
            <Link
              target="_blank"
              href={
                setting?.socialLinks.find((link) => link.linkType === "Twitter")
                  ?.linkUrl
              }
              color="inherit"
            >
              <Twitter />
            </Link>
            <Link
              target="_blank"
              href={
                setting?.socialLinks.find(
                  (link) => link.linkType === "LinkedIn"
                )?.linkUrl
              }
              color="inherit"
            >
              <LinkedIn />
            </Link>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              About Us
            </Typography>
            <Typography>
              <span
                dangerouslySetInnerHTML={{
                  __html: setting?.about ?? "",
                }}
              ></span>
            </Typography>
          </Grid>
        </Grid>
        <Box mt={2}>
          <Typography variant="body2" color="text.secondary" align="center">
            {"Copyright © "}
            <Link
              target="_blank"
              color="inherit"
              href="https://targetweb.site/"
            >
              Target web
            </Link>{" "}
            {new Date().getFullYear()}
            {"."}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};
